import React, { useCallback, useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface NavbarProps {
  language: 'en' | 'es';
}
export function Navbar({
  language
}: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const t = {
    en: {
      home: 'Home',
      services: 'Services',
      serviceAreas: 'Service Areas',
      about: 'About',
      faq: 'FAQ',
      contact: 'Contact',
      quoteBtn: 'REQUEST A FREE QUOTE →'
    },
    es: {
      home: 'Inicio',
      services: 'Servicios',
      serviceAreas: 'Áreas de Servicio',
      about: 'Nosotros',
      faq: 'Preguntas Frecuentes',
      contact: 'Contacto',
      quoteBtn: 'SOLICITA COTIZACIÓN GRATIS →'
    }
  };
  const text = t[language];
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: text.home,
    href: '#home'
  }, {
    name: text.services,
    href: '#services'
  }, {
    name: text.serviceAreas,
    href: '#service-areas'
  }, {
    name: text.about,
    href: '#about'
  }, {
    name: text.faq,
    href: '#faq'
  }, {
    name: text.contact,
    href: '#contact'
  }];
  const handleMobileNavClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    setTimeout(() => {
      const targetId = href.replace('#', '');
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 150);
  }, []);
  return <nav className={`sticky top-0 z-50 transition-all duration-300 bg-obsidian w-full overflow-hidden ${isScrolled ? 'border-b-2 border-gold shadow-lg shadow-black/50' : ''}`} data-id="element-203">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
        <div className="flex justify-between items-center min-h-[80px] py-3" data-id="element-205">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center mr-12" data-id="element-206">
            <a href="#home" className="flex items-center" data-id="element-207">
              <img src="https://cdn.magicpatterns.com/uploads/6XMJLNcqaWm4GULsPBmP2x/logo_1.png" alt="Blackstone Rentals" className="h-[72px] w-auto" data-id="element-208" />
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-209">
            <div className="flex space-x-6" data-id="element-210">
              {navLinks.map(link => <a key={link.href} href={link.href} className="text-warmWhite hover:text-gold transition-colors font-inter text-sm font-medium" data-id="element-211">
                  {link.name}
                </a>)}
            </div>
            <a href="#quote" className="bg-gold text-black px-6 py-2.5 rounded font-montserrat font-bold text-sm tracking-wide hover:bg-yellow-500 hover:scale-105 transition-all duration-300" data-id="element-212">
              {text.quoteBtn}
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-213">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-warmWhite hover:text-gold focus:outline-none" data-id="element-214">
              {isMobileMenuOpen ? <X size={28} data-id="element-215" /> : <Menu size={28} data-id="element-216" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-217">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.2
      }} className="md:hidden bg-carbon border-b border-gold overflow-hidden" data-id="element-218">
            <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-219">
              {navLinks.map(link => <a key={link.href} href={link.href} onClick={e => handleMobileNavClick(e, link.href)} className="block px-3 py-3 text-base font-medium text-warmWhite hover:text-gold hover:bg-steel rounded-md transition-colors" data-id="element-220">
                  {link.name}
                </a>)}
              <a href="#quote" onClick={e => handleMobileNavClick(e, '#quote')} className="block w-full text-center mt-4 bg-gold text-black px-6 py-3 rounded font-montserrat font-bold text-sm tracking-wide" data-id="element-221">
                {text.quoteBtn}
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}